export default __webpack_public_path__ + "static/Avenir-Book-01-b2a8c3d69218fdc683988344dbf28e6c.woff";